import { render, staticRenderFns } from "./ProjectStageLabel.vue?vue&type=template&id=768fd055&"
import script from "./ProjectStageLabel.vue?vue&type=script&lang=js&"
export * from "./ProjectStageLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports